<template>
  <div class="row">
    <div class="col">
      <label for="">شروع</label>
      <input readonly type="text" v-model="reservationItem.start" class="form-control">
    </div>
    <div class="col">
      <label for="">پایان</label>
      <input readonly type="text" v-model="reservationItem.end" class="form-control">
    </div>
    <div class="col">
      <label for="">قیمت</label>
      <input @keydown="changeItem(reservationItem)" type="number" pattern="\d+" v-model="reservationItem.price" class="form-control">
    </div>
    <div class="col">
      <label for="">تخفیف</label>
      <input @keydown="changeItem(reservationItem)" type="number" pattern="\d+" v-model="reservationItem.offer" class="form-control">
    </div>

    <div class="border my-3" style="height: 1px;width: 100%"></div>

  </div>
</template>

<script>
export default {
  name: "ReservationInput",
  props: {
    reservation: {},
    reservationItem: {}
  },
  methods: {
    mutateReservationItemOnRules(item) {
      let reservationRules = Object.assign({}, this.$store.getters['Reservation/getReservationRule']);

      // convert itemStart with shape timestamp to only day format like 2023-06-28
      const itemStart = new Date(item['start'])
          .toLocaleDateString('en-GB', {year: 'numeric', month: '2-digit', day: '2-digit'})
          .split(' ')[0].split('/').reverse().join('-')
      reservationRules.custom_price[itemStart] = item
      this.$store.commit('Reservation/setReservationRule', reservationRules)
    },
    changeItem(data) {
      this.mutateReservationItemOnRules(data)
    },

  }
}
</script>


<style>

</style>